import React from 'react';
import { Form, FormGroup, Label, Input, Button, Row, Col, Modal, ButtonToolbar } from 'reactstrap';
import Select from 'react-select';
import API from '../../../Common/api';
import XLSX from "xlsx";
import { MDBDataTable } from 'mdbreact';



import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import blueDownloadIcon from '../../../../images/blueDownloadIcon.svg';
import blackUploadIcon from '../../../../images/blackUploadIcon.svg';
import DatePicker from "react-datepicker";
import exportToCSVNew from '../../../Common/exportcsvnew';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt, faSpinner } from "@fortawesome/free-solid-svg-icons";
import editIcon from '../../../../images/pencil-alt.svg';
import dustbinIcon from '../../../../images/dustbin-alt.svg';






var expected_delivery_date;

class HorizontalForm extends React.Component {
  constructor(props) {
    super(props);
    window.handleAddNewItem = this.handleAddNewItem.bind(this);
    this.state = {
      po_header: [{ "Item Code": "", "Item Description": "", "Mrp": "", "Item Level Discount": "", "Quantity": "", "Pre Tax": "", "Post Tax": "", "UOM": "", "Cost": "" }],
      username: '',
      employeeCode: '',
      searchTerm: '',
      posts: [],
      failedModal: false,
      itemIndex: null,
      itemCode: "",
      confirmModal: false,
      supplierCodeData: [],
      subCategoryList: [],
      divisionData: [],
      modalAddItem: false,
      selectedFile: null,
      selectedFileInvoice: null,
      editingIndex: null, // to track which row is being edited
      expected_delivery_date: null,
      selected_supplier_id: "",
      full_address: "",
      sub_category: "",
      brandList: [],
      modalNew: false,
      fileErrorInvoice: '',
      fullName: '',
      email: '',
      mobile: '',
      city: '',
      role: null,
      tax_type: "",
      tax_community: "",
      inventoryOwner: null,
      supplier_code: "",
      confirmMessage: "",
      dropDownData: [],
      warehouses: [],
      warehouses_val: [],
      warehousesList: [],
      availableRoles: [],
      taxType: [],
      availableOwners: [],
      taxCommunity: [],
      username_val: '',
      password: '',
      errors: {},
      isAccordionOpen: false,
      sectionStatus: {
        itemDetails: false,
        productAttributes: false,
        pricingDetails: false,
        uomDetails: false
      }
    };
  }



  insertAddItemButton = () => {

    this.insertButtonInterval = setInterval(() => {
      const targetDiv = document.querySelector('div[data-test="datatable-search"]');
      const searchInputDiv = document.querySelector('div[data-test="datatable-input"]');
      const refDiv = document.querySelector('div[data-test="datatable-entries"]');

      // Safeguard: Only proceed if refDiv exists
      if (refDiv) {
        // Check if the heading text already exists inside refDiv
        const alreadyExists = Array.from(refDiv.childNodes).some(node =>
          node.textContent && node.textContent.trim() === "PO Line items"
        );

        if (!alreadyExists) {
          const span = document.createElement('span');
          span.innerHTML = '<strong style={{fontSize: 18}}>PO Line items</strong>';
          span.style.marginRight = '10px';
          span.style.fontSize = '16px';
          refDiv.insertBefore(span, refDiv.firstChild);
        }
      }


      if (targetDiv && searchInputDiv && !document.getElementById('add-new-item-button')) {
        const button = document.createElement('button');

        button.innerText = '➕ Add New Item';
        button.id = 'add-new-item-button';
        button.style.border = '1px solid #FFCB05';
        button.style.background = 'white';
        button.style.color = '#333';
        button.style.fontWeight = '500';
        button.style.padding = '9px 12px';
        button.style.borderRadius = '8px';
        button.style.fontSize = '14px';
        button.style.cursor = 'pointer';
        button.style.marginRight = '12px';

        const self = this;

        button.addEventListener('click', function () {
          self.addItemModal();
        });

        targetDiv.insertBefore(button, searchInputDiv);
        clearInterval(this.insertButtonInterval);
      }
    }, 300);
  };

  addItemModal = () => {
    //alert("hi");
    console.log("ADD Item")
    this.setState({
      editingIndex: null,
      modalAddItem: true,
      modalHeading: 'Add New Item',
      sl_num: this.state.posts.length + 1,
      item_code: "",
      item_description: "",
      mrp: "",
      item_level_discount: "",
      quantity: "",
      pre_tax: "",
      post_tax: "",
      cost: "",
      uom: "",



    })
    //this.toggleNewModal()
  }

  editItem = (index, item) => {
    console.log('Edit Item')
    this.setState({
      editingIndex: index,
      sl_num: index + 1, // or item.sl_num if present
      item_code: item.item_code,
      item_description: item.item_description,
      mrp: item.mrp,
      item_level_discount: item.item_level_discount,
      quantity: item.quantity,
      pre_tax: item.pre_tax,
      post_tax: item.post_tax,
      uom: item.uom,
      cost: item.cost,
      modalHeading: 'Edit Item',
      modalAddItem: true,
    });
  };

  handleFileUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      const expectedHeaders = [
        "Item Code",
        "Item Description",
        "Mrp",
        "Item Level Discount",
        "Quantity",
        "Pre Tax",
        "Post Tax",
        "UOM",
        "Cost"
      ];

      const keyMap = {
        "Item Code": "item_code",
        "Item Description": "item_description",
        "Mrp": "mrp",
        "Item Level Discount": "item_level_discount",
        "Quantity": "quantity",
        "Pre Tax": "pre_tax",
        "Post Tax": "post_tax",
        "UOM": "uom",
        "Cost": "cost"
      };

      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        // Header validation
        const rawData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        const headersFromFile = rawData[0].filter(h => h !== "S.NO"); // Ignore "S.NO" column

        const isValid = expectedHeaders.every(header => headersFromFile.includes(header)) &&
          headersFromFile.length === expectedHeaders.length;

        if (!isValid) {
          this.setState({
            selectedFile: null,
            posts: [],
            fileError: "Please upload a valid template file.",
          });
          return;
        }

        // Transform data
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        const transformedData = jsonData.map(row => {
          const newRow = {};
          Object.keys(row).forEach(key => {
            if (keyMap[key]) {
              newRow[keyMap[key]] = row[key];
            }
          });
          newRow["product"] = ""; // Add default key
          return newRow;
        });
        const totalAmount = transformedData.reduce((sum, item) => {
          const mrp = parseFloat(item.mrp) || 0;
          const qty = parseFloat(item.quantity) || 0;
          return sum + (mrp * qty);
        }, 0);
        /*const billLevelDiscount = transformedData.reduce((sum, item) => {
          const billDiscountVal = parseFloat(item.item_level_discount) || 0;
          const qtyVal = parseFloat(item.quantity) || 0;
          return sum + (billDiscountVal * qtyVal);
        }, 0);*/


        console.log("Validated + Transformed Excel Data:", transformedData);

        this.setState({
          selectedFile: file,
          posts: transformedData,
          fileError: null,
          total_bill_amount: totalAmount,
          //bill_level_discount: billLevelDiscount
        });
        this.insertAddItemButton();
        window.toggleNewModal = this.toggleAddItem;

      };

      reader.readAsArrayBuffer(file);
    }
    event.target.value = null;
  };

  handleAddItemSubmit = () => {
    const {
      editingIndex,
      item_code,
      item_description,
      mrp,
      item_level_discount,
      quantity,
      pre_tax,
      post_tax,
      uom,
      cost,
      posts
    } = this.state;

    const newItem = {
      item_code,
      item_description,
      mrp,
      item_level_discount,
      quantity,
      pre_tax,
      post_tax,
      uom,
      cost,
    };

    let updatedPosts = [];

    if (editingIndex !== null) {
      // ✅ Update existing item
      updatedPosts = [...posts];
      updatedPosts[editingIndex] = { ...newItem, sno: editingIndex + 1 };
    } else {
      // ✅ Add new item
      updatedPosts = [...posts, { ...newItem, sno: posts.length + 1 }];
    }

    // ✅ Recalculate totalAmount (mrp * quantity for all items)
    const totalAmount = updatedPosts.reduce((sum, item) => {
      const mrpVal = parseFloat(item.mrp) || 0;
      const qtyVal = parseFloat(item.quantity) || 0;
      return sum + (mrpVal * qtyVal);
    }, 0);
    /*const billLevelDiscount = updatedPosts.reduce((sum, item) => {
      const billDiscountVal = parseFloat(item.item_level_discount) || 0;
      const qtyVal = parseFloat(item.quantity) || 0;
      return sum + (billDiscountVal * qtyVal);
    }, 0);*/

    // ✅ Update state
    this.setState({
      posts: updatedPosts,
      total_bill_amount: totalAmount,
      //bill_level_discount: billLevelDiscount,
      editingIndex: null,
      modalAddItem: false,

      // Reset form fields
      item_code: '',
      item_description: '',
      mrp: '',
      item_level_discount: '',
      quantity: '',
      pre_tax: '',
      post_tax: '',
      uom: '',
      cost: '',
    });
  };



  invoiceFileUpload = (event) => {
    const file = event.target.files[0];
    console.log(file);

    if (file && file.type === "application/pdf") {
      // ✅ Clear invoice upload error if present
      const updatedErrors = { ...this.state.formErrors };
      if (updatedErrors.invoice_upload) {
        delete updatedErrors.invoice_upload;
        this.setState({ formErrors: updatedErrors });
      }

      this.setState({ selectedFileInvoice: file });

      const reader = new FileReader();
      reader.onload = (e) => {
        const base64PDF = e.target.result;
        console.log("PDF file uploaded:", file.name);

        // You can later send this base64PDF to backend or display in iframe
        this.setState({ pdfDataUrl: base64PDF });
      };

      reader.readAsDataURL(file); // To preview or send to server as base64
    } else {
      this.setState({
        selectedFileInvoice: null,
        pdfDataUrl: null,
        fileErrorInvoice: 'Please upload a valid PDF file.'
      });
      //alert("Please upload a valid PDF file.");
    }
  };



  removeUploadedFile = () => {
    this.setState({ selectedFile: null, posts: [] });
  };

  removeInvoiceUploadedFile = () => {
    this.setState({ selectedFileInvoice: null, postsInvoice: [], pdfDataUrl: null, });
  };

  handleAddNewItem = () => {
    // Add new row or trigger modal
  };

  handleSearchInput = (e) => {
    this.setState({ searchTerm: e.target.value });
  };

  handleKeyDown = (e) => {
    // Optional: Handle enter key
  };

  Failedtoggle = () => {
    this.setState((prevState) => ({ failedModal: !prevState.failedModal }));
  }
  confirmToggle = (index, item_code) => {
    this.setState((prevState) => ({
      confirmModal: !prevState.confirmModal, itemIndex: index, itemCode: item_code, confirmMessage: (
        <>
          Are you sure want to remove the <strong>Item - </strong> <strong>{item_code}</strong> from list ?
        </>
      )
    }));

  }

  toggleNew = () => {
    this.setState((prevState) => ({ modalNew: !prevState.modalNew }));
  }
  toggleAddItem = () => {
    this.setState((prevState) => ({ modalAddItem: !prevState.modalAddItem }));
  }

  toggleBack = () => {
    window.location.href = "/receiving/purchase_order";
  }

  getSupplierCode = (value) => {
    API.get('/receiving/po-creation/supplier?warehouse=' + value)
      .then((response) => response.data)

      .then((data) => {
        console.log("Supplier", data);
        this.setState({ supplierCodeData: data.data });
      })

      .then(async () => {

      });

  }

  /*handleChange = (event) => {
      const { name, value } = event.target;
      this.setState({ [name]: value, errors: { ...this.state.errors, [name]: '' } });
  };*/
  /*handleChange = (event) => {
      const { name, value } = event.target;
      this.setState(
          { [name]: value, errors: { ...this.state.errors, [name]: '' } },
          () => {
              
          }
      );
  };*/
  handleChange = (e) => {
    const { name, value } = e.target;

    // Update supplier_code in state
    this.setState({ [name]: value }, () => {
      // If there's an error for this field, clear it once it's filled
      if (this.state.formErrors && this.state.formErrors[name] && value) {
        const updatedErrors = { ...this.state.formErrors };
        delete updatedErrors[name];
        this.setState({ formErrors: updatedErrors });
      }
    });
    if (name === "warehouse") {
      this.getBrand(value)
    }
    if (name === "brand") {
      this.getSupplierCode(this.state.warehouse + ' || ' + value)
    }

    // If the changed field is supplier_code, find selected supplier details
    if (name === "supplier_code") {
      const selectedSupplier = this.state.supplierCodeData.find(
        (item) => item.name === value
      );

      if (selectedSupplier) {
        console.log('selectedSupplier', selectedSupplier.name)
        this.setState({
          vendor_name: selectedSupplier.name,
          trade_name: selectedSupplier.trade_name,
          selected_supplier_id: selectedSupplier.id,
          location: selectedSupplier.location,
          full_address: selectedSupplier.customer_addresses && selectedSupplier.customer_addresses[0] ? selectedSupplier.customer_addresses[0] : ""
        });
      }

      else {
        this.setState({
          vendor_name: "",
          trade_name: "",
          selected_supplier_id: "",
          full_address: "",
        });
      }

      console.log("Details", selectedSupplier.id, selectedSupplier.customer_addresses[0])
    }
  };
  isSectionComplete = (section) => {
    switch (section) {
      case 'itemDetails':
        return (
          this.state.item_code &&
          this.state.item_name &&
          this.state.item_type &&
          this.state.item_category &&
          this.state.sub_category &&
          this.state.brand &&
          this.state.sub_brand &&
          this.state.hsn_code &&
          this.state.hht_item_desc
        );
      case 'productAttributes':
        return (
          this.state.ean &&
          this.state.upc &&
          this.state.ean_each_length &&
          this.state.ean_each_breadth &&
          this.state.ean_each_height &&
          this.state.ean_cases_length &&
          this.state.ean_cases_breadth &&
          this.state.ean_cases_height
        );
      case 'pricingDetails':
        return (
          this.state.mrp &&
          this.state.std_cost &&
          this.state.per_qty
        );
      case 'uomDetails':
        return (
          this.state.purchase_uom &&
          this.state.std_purchase_price &&
          this.state.sales_uom
        );
      default:
        return false;
    }
  };

  componentDidMount() {
    this.getDropDownData();
    // this.getSupplierCode(this.getCookie("selectedLocation"));
    this.getWarehouseData();
    this.insertAddItemButton();
    this.getSubCategory();
    // this.getBrand();
    window.toggleNewModal = this.toggleAddItem;
    const accordion = document.getElementById("create_item_accordian");
    const accordion_buttons = document.getElementsByClassName("accordion__button");
    const accordion_items = document.getElementsByClassName("accordion__item");
    const accordion__panel = document.getElementsByClassName("accordion__panel");

    if (accordion) {
      accordion.style.setProperty("width", "92%", "important");
      accordion.style.setProperty("border", "0px", "important");
    }


    if (accordion_buttons.length > 0) {  // Check if elements exist
      for (let button of accordion_buttons) {
        button.style.setProperty("background-color", "#fff", "important");
        button.style.setProperty("font-weight", "bold", "important");
      }

    }

    if (accordion_items.length > 0) {  // Check if elements exist
      for (let button of accordion_items) {
        button.style.setProperty("margin-bottom", "10px", "important");
        button.style.setProperty("border", "0px", "important");

      }

    }

    if (accordion__panel.length > 0) {  // Check if elements exist
      for (let button of accordion__panel) {
        button.style.setProperty("background-color", "#fff", "important");


      }

    }
  }

  /* handleFileUpload = (event) => {
       const file = event.target.files[0];
       if (file) {
           console.log("File selected:", file.name);
           // You can update state or handle file upload here
       }
   };*/

  getBrand = (value) => {

    API.get('/tax/v1/filter/brands?warehouse_master_code=' + value)
      .then((response) => response.data)

      .then((data) => {
        console.log("brand", data);

        this.setState({ brandList: data.data });
      })

      .then(async () => {

      });
  }

  getSubCategory = () => {

    API.get('/receiving/po-creation/sub-category')
      .then((response) => response.data)

      .then((data) => {
        console.log("brand", data);

        this.setState({ subCategoryList: data.data });
      })

        .then(async () => {
          
        });
    }

  getDropDownData = () => {
    API.get('/tax/v1/item-list/product/dropdown/')
      .then((response) => response.data)
      .then((data) => {

        this.setState({
          dropDownData: data.data,
          divisionData: data.data.division
        })
      })
      .catch((error) => console.error(error));
  };

  getWarehouseData = () => {
    API.get('/receiving/po-creation/warehouse-list')
      .then((response) => response.data)
      .then((data) => {

        console.log("Warehouse", data)
        this.setState({
          warehousesList: data.data
        })
      })
      .catch((error) => console.error(error));
  };

  convertDate = (inputDate) => {
    const pad = (s) => (s < 10 ? '0' + s : s);
    const d = new Date(inputDate);
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  };

  // Date change handler
  ExpectedDateChange = (date) => {
    if (date) {
      const formatted = this.convertDate(date);
      console.log("Expected date (formatted):", formatted);

      this.setState({
        expected_delivery_date: date, // keep it as a Date object for DatePicker
        formatted_delivery_date: formatted,
        loading: !this.state.loading,
      }, () => {
        // Clear error if it was set and user selected a date
        if (this.state.formErrors && this.state.formErrors.expected_delivery_date) {
          const updatedErrors = { ...this.state.formErrors };
          delete updatedErrors.expected_delivery_date;
          this.setState({ formErrors: updatedErrors });
        }
      });
    } else {
      this.setState({
        expected_delivery_date: null,
        loading: false,
      });
    }
  };

  removeItem = (indexToRemove, item_code) => {
    let newPostData = this.state.posts.filter((_, index) => index !== indexToRemove)

    const totalAmount = newPostData.reduce((sum, item) => {
      const mrpVal = parseFloat(item.mrp) || 0;
      const qtyVal = parseFloat(item.quantity) || 0;
      return sum + (mrpVal * qtyVal);
    }, 0);
    /*const billLevelDiscount = newPostData.reduce((sum, item) => {
      const billDiscountVal = parseFloat(item.item_level_discount) || 0;
      const qtyVal = parseFloat(item.quantity) || 0;
      return sum + (billDiscountVal * qtyVal);
    }, 0);*/
    this.setState((prevState) => ({
      posts: newPostData,
      total_bill_amount: totalAmount,
      confirmModal: false
      //bill_level_discount: billLevelDiscount

    }));

    if (newPostData.length === 0) {
      this.removeUploadedFile();
    }
  };

  createItem = () => {
    const {
      expected_delivery_date,
      sub_category,
      division,
      total_bill_amount,
      invoice_number,
      warehouse,
      supplier_code,
      brand
    } = this.state;

    let errors = {};

    if (!expected_delivery_date) errors.expected_delivery_date = "This field is required.";
    if (!sub_category) errors.sub_category = "This field is required";
    if (!division) errors.division = "This field is required.";
    if (!total_bill_amount) errors.total_bill_amount = "This field is required.";
    if (!invoice_number) errors.invoice_number = "This field is required.";
    if (!warehouse) errors.warehouse = "This field is required.";
    if (!supplier_code) errors.supplier_code = "This field is required";
    if (!brand) errors.brand = "This field is required.";
    //if (!selectedFileInvoice) errors.invoice_upload = "Invoice file is required.";
    if (!this.state.selectedFileInvoice) {
      errors.invoice_upload = "Invoice file is required.";
    }


    if (Object.keys(errors).length > 0) {
      this.setState({ formErrors: errors });
      return;
    }
    this.setState({ loading: true });

    const payload = {
      expected_delivery_date: this.state.formatted_delivery_date,
      sub_category: this.state.sub_category,
      division: this.state.division,
      total_bill_amount: this.state.total_bill_amount,
      bill_level_discount: this.state.bill_level_discount,
      warehouse_code: this.state.warehouse,
      brand: this.state.brand,
      invoice_number: this.state.invoice_number,
      term_condition: this.state.term_condition,
      notes_description: this.state.notes_description,
      supplier: this.state.supplier_code,
      po_items: this.state.posts,
      created_by: 2,
    };

    API.post('/receiving/po-creation', { param: payload })
      .then((response) => {
        console.log("Created PO Data", response);
        const { data, status } = response;
        console.log(data.status, data, data.data)

        if ((status === 201 || data.status === "true") && data.data.id) {
          const poId = data.data.id;
          /*const invoiceFile = this.state.selectedFileInvoice;

          if (invoiceFile) {
            const formData = new FormData();
            formData.append("invoice", invoiceFile);

            // Upload the invoice
            return API.post(`/receiving/po-creation/invoice/${poId}`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: this.props.auth_token || localStorage.getItem("auth_token")
              },
            })
              .then((uploadResponse) => {
                console.log("Invoice uploaded", uploadResponse);

                this.setState({
                  success_message: uploadResponse.data.message || data.message,
                  modalNew: true,
                  loading: false,
                });
              })
              .catch((uploadError) => {
                console.error("Invoice Upload Error", uploadError);
                this.setState({
                  success_message: "PO created, but invoice upload failed.",
                  modalNew: true,
                  loading: false,
                });
              });
          }*/

          const invoiceFile = this.state.selectedFileInvoice;

          if (invoiceFile) {
            const formData = new FormData();

            formData.append("invoice", this.state.selectedFileInvoice);

            API.post2(`/receiving/po-creation/invoice/${poId}`, {
              param: formData,
            })
              .then((uploadResponse) => {
                console.log("Invoice uploaded", uploadResponse);
                this.setState({
                  success_message: uploadResponse.data.message,
                  modalNew: true,
                  loading: false,
                });
              })
              .catch((uploadError) => {
                console.error("Invoice Upload Error", uploadError);
                this.setState({
                  success_message: "PO created, but invoice upload failed.",
                  modalNew: true,
                  loading: false,
                });
              });

          }

          // If no file was selected, just show PO creation success
          this.setState({
            success_message: data.message,
            modalNew: true,
            loading: false,
          });
        } else {
          this.setState({
            failed_message: data.message,
            failedModal: true,
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 400) {
          const errorData = error.response.data;
          const errors = errorData.data ? Object.values(errorData.data).flat() : [];

          const formattedErrorString = errors.join(', '); // Only values, comma-separated

          this.setState({
            failed_message: formattedErrorString,
            failed_errors: errors,
            failedModal: true,
            loading: false,
          });
        } else {
          console.error(error);
          this.setState({ loading: false });
        }
      });
  };

  handleAccordionToggle = (isOpen) => {
    this.setState({ isAccordionOpen: isOpen });
  };

  render() {
    const { errors, modalNew, failedModal, dropDownData, selectedFile, selectedFileInvoice, posts, searchTerm, modalAddItem, confirmModal } = this.state;
    console.log("POSTDATARENDER", this.state.posts);
    return (
      <div id="createItem_container" style={{ width: '100%', margin: '1%' }}>

        <Accordion
          id="create_item_accordian"
          style={{ width: '100%', maxWidth: '100vw' }}
          allowMultipleExpanded
          allowZeroExpanded
          onChange={(expandedItems) => this.handleAccordionToggle(expandedItems.length > 0)}
        >
          {/* Section 1 */}
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton id="accordion_button">
                <span className="accordian_title">Request Details</span>
                {/*<span style={{ float: "right", color: this.state.sectionStatus.itemDetails ? "green" : "orange" }}>
                                        <i className={`fa ${this.state.sectionStatus.itemDetails ? "fa-check-circle" : "fa-exclamation-circle"}`}></i>
                                        {this.state.sectionStatus.itemDetails ? " Completed" : " Pending"}
                                    </span>*/}
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="username">PO Number </Label>
                                            <Input
                                                type="text"
                                                name="po_number"
                                                value={this.state.po_number}
                                                onChange={this.handleChange}
                                                disabled
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Warehouse <span style={{ color: "red" }}>*</span></Label>
                                            <select
                                                name="warehouse"
                                                className="form-control"
                                                value={this.state.warehouse}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                            >
                                                <option value="">Select</option>
                                                {this.state.warehousesList.map((item) => (
                                                
                                                    <option key={item.id} value={item.code}>{item.code}</option>
                                                ))}
                                            </select>
                                            {this.state.formErrors && this.state.formErrors.warehouse && (
                                              <div style={{ color: 'red', fontSize: 12 }}>{this.state.formErrors.warehouse}</div>
                                            )}
                                        </FormGroup>
                                    </Col>
                                     <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Brand <span style={{ color: "red" }}>*</span></Label>
                                            <select
                                                name="brand"
                                                className="form-control"
                                                value={this.state.brand}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                            >
                                                <option value="">Select</option>
                                                {this.state.brandList.map((item) => (
                                                
                                                    <option key={item.id} value={item.code}>{item.code}</option>
                                                ))}
                                            </select>
                                            {this.state.formErrors && this.state.formErrors.brand && (
                                              <div style={{ color: 'red', fontSize: 12 }}>{this.state.formErrors.brand}</div>
                                            )}
                                        </FormGroup>
                                    </Col>
                                    {/*<Col md={4}>
                                        
                                            <Label for="city">PO Date</Label>
                                            <div id="date_picker_container" style={{ position: 'relative' }}>
                                              <DatePicker
                                                  id="ledger_fromdate"
                                                  selected={this.state.po_date}
                                                  onChange={this.FromDateChange}
                                                  className="ledger_fromdate"
                                                  placeholderText="PO Date"
                                                  format='yyyy-MM-dd'
                                                  
                                              />
                                              <i className="fa fa-calendar" style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none' }}></i>
                                            </div>


                                        

                                    </Col>*/}

                                </Row>
                                <Row form>
                                    <Col md={4}>
                                            <Label for="username">Expected Delivery Date <span style={{ color: "red" }}>*</span></Label>
                                             <div id="date_picker_container" style={{ position: 'relative' }}>
                                                <DatePicker
                                                  id="ledger_fromdate"
                                                  selected={this.state.expected_delivery_date || null}
                                                  onChange={this.ExpectedDateChange}
                                                  className="ledger_fromdate"
                                                  placeholderText="Expected Delivery Date"
                                                  dateFormat="yyyy-MM-dd"
                                                  autoComplete="off"
                                                  popperClassName="datepicker-popper"
                                                  minDate={new Date()}
                                                />
                                              <i className="fa fa-calendar" style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none' }}></i>
                                            </div>
                                            {this.state.formErrors && this.state.formErrors.expected_delivery_date && (
                                              <div style={{ color: 'red', fontSize: 12 }}>{this.state.formErrors.expected_delivery_date}</div>
                                            )}
                                        
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Sub Category <span style={{ color: "red" }}>*</span></Label>
                                            <select
                                                name="sub_category"
                                                className="form-control"
                                                value={this.state.sub_category}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                            >
                                                <option value="">Select</option>
                                                {/*<option value={dropDownData.sub_category}>{dropDownData.sub_category}</option>*/}
                                                {this.state.subCategoryList.map((item) => (
                                                    <option key={item} value={item}>{item}</option>
                                                ))}
                                            </select>
                                            {this.state.formErrors && this.state.formErrors.sub_category && (
                                              <div style={{ color: 'red', fontSize: 12 }}>{this.state.formErrors.sub_category}</div>
                                            )}
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Division<span style={{ color: "red" }}>*</span></Label>
                                            <select
                                                name="division"
                                                className="form-control"
                                                value={this.state.division}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                            >
                                                <option value="">Select</option>
                                                

                                                {this.state.divisionData.map((item) => (
                                                    <option key={item} value={item}>{item}</option>
                                                ))}
                                            </select>
                                             {this.state.formErrors && this.state.formErrors.division && (
                                              <div style={{ color: 'red', fontSize: 12 }}>{this.state.formErrors.division}</div>
                                            )}
                                        </FormGroup>
                                    </Col>

              </Row>


              <Row style={{ display: 'none' }} form>
                <Col md={4} style={{ border: '1px solid', borderColor: '#AAAAAA33', padding: '10px' }} className="d-flex justify-content-center">
                  <div
                    style={{
                      border: "2px dashed orange",
                      backgroundColor: "#FFF3CD",
                      padding: "20px",
                      textAlign: "center",
                      width: "50%",
                      borderRadius: "8px",
                      cursor: "pointer"
                    }}
                    onClick={() => document.getElementById("fileUpload").click()}
                  >
                    <input
                      type="file"
                      id="fileUpload"
                      style={{ display: "none" }}
                      onChange={this.handleFileUpload}
                      accept="xlsx/*"
                    />
                    {/*<img
                                                src={}
                                                alt="upload"
                                                style={{ width: '25px',  }} 
                                            />*/}
                    <p style={{ margin: "10px 0", color: "#000" }}>Upload Item Image</p>
                  </div>
                </Col>
              </Row>
            </AccordionItemPanel>
          </AccordionItem>

          {/* Section 2 */}
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton id="accordion_button">
                <span className="accordian_title">Vendor Information</span>
                {/*<span style={{ float: "right", color: this.state.sectionStatus.productAttributes ? "green" : "orange" }}>
                                        <i className={`fa ${this.state.sectionStatus.productAttributes ? "fa-check-circle" : "fa-exclamation-circle"}`}></i>
                                        {this.state.sectionStatus.productAttributes ? " Completed" : " Pending"}
                                    </span>*/}
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="email">Supplier Code<span style={{ color: "red" }}>*</span></Label>
                                            <select
                                                className="form-control"
                                                value={this.state.supplier_code}
                                                style={{ fontSize: 13 }}
                                                name="supplier_code"
                                                onChange={this.handleChange}
                                            >
                                                <option value="">Select</option>
                                                {this.state.supplierCodeData.length > 0 &&
                                                  this.state.supplierCodeData.map((items) => {
                                                    return (
                                                      <option value={items.name}>
                                                        {" "}
                                                        {items.name}
                                                      </option>
                                                    );
                                                  })}
                                            </select>
                                            {this.state.formErrors && this.state.formErrors.supplier_code && (
                                              <div style={{ color: 'red', fontSize: 12 }}>{this.state.formErrors.supplier_code}</div>
                                            )}
                                        </FormGroup>
                                    </Col>
                                    
                                </Row>
                                <Row form>
                                     <Col md={4}>
                                        
                                        <FormGroup>
                                            <Label for="mobile">Vendor Name</Label>
                                            <Input
                                                type="text"
                                                name="vendor_name"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                value={this.state.vendor_name}
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Location</Label>
                                            <Input
                                                type="text"
                                                name="location"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                value={this.state.location}
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                                     <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Trade Name</Label>
                                            <Input
                                                type="text"
                                                name="trade_name"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                value={this.state.trade_name}
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>

              <Row form>
                <Col md={12}>

                  <FormGroup>
                    <Label for="mobile">Full Address</Label>
                    <Input
                      type="text"
                      name="full_address"
                      id="mobile"
                      disabled
                      onChange={this.handleChange}
                      value={this.state.full_address}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </AccordionItemPanel>
          </AccordionItem>

          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton id="accordion_button">
                <span className="accordian_title">PO Bulk Upload</span>
              </AccordionItemButton>
            </AccordionItemHeading>

            <AccordionItemPanel>
              <div>
                <span style={{ color: 'black', fontWeight: 500 }}>Upload PO Line Items in bulk</span>

                {/* Upload Area */}
                <div style={{ display: 'flex', alignItems: 'center', marginTop: 16 }}>
                  {/* Upload or File Display */}
                  {/* Upload or File Display */}
                  {!selectedFile ? (
                    <div
                      style={{
                        display: 'flex',
                        border: '1px solid #E4E4E7',
                        padding: '10px 12px',
                        borderRadius: '10px',
                        alignItems: 'center',
                        minWidth: 300,
                        maxWidth: 400,
                      }}
                    >
                      <span style={{ fontSize: 13, color: '#7C7C85', flex: 1 }}>Upload documents in .XLS</span>
                      <input
                        type="file"
                        accept=".xls,.xlsx"
                        style={{ display: 'none' }}
                        id="fileUpload"
                        onChange={this.handleFileUpload}
                      />


                      <label htmlFor="fileUpload" style={{ fontSize: 12, color: '#121212', padding: '6px 15px', border: '1px solid #FFCB05', borderRadius: 8, cursor: 'pointer' }}>
                        <img src={blackUploadIcon} style={{ width: '22%' }} /> Attach
                      </label>
                    </div>
                  ) : (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        border: '1px solid #E4E4E7',
                        padding: '8px 12px',
                        borderRadius: '10px',
                        backgroundColor: '#F2F4F7',
                        minWidth: 300,
                        maxWidth: 400,
                      }}
                    >
                      <span style={{ color: '#1E90FF', fontSize: 13, flex: 1 }}>
                        {selectedFile.name}
                      </span>
                      <button
                        onClick={this.removeUploadedFile}
                        style={{
                          border: 'none',
                          background: 'transparent',
                          cursor: 'pointer',
                          fontSize: 16,
                          color: '#777',
                        }}
                      >
                        ✖
                      </button>
                    </div>
                  )}


                  {/* Sample Download */}
                  <a
                    onClick={(e) =>
                      exportToCSVNew(
                        this.state.po_header,
                        "PO_Template"
                      )
                    }
                    download
                    style={{
                      fontSize: 13,
                      color: '#33A0FF',
                      textDecoration: 'none',
                      marginLeft: 15,
                      width: '100%'
                    }}
                  >
                    <img src={blueDownloadIcon} style={{ width: '3%', marginRight: 5 }} />
                    Download Sample

                  </a>
                </div>
                {this.state.fileError && (
                  <div style={{ color: 'red', marginTop: 8 }}>
                    {this.state.fileError}
                  </div>
                )}
              </div>

              {/* Add & Search */}
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 30 }}>


                {/* <input
                                      type="text"
                                      placeholder="Search"
                                      className="form-control"
                                      style={{ width: 200, fontSize: 13 }}
                                      value={searchTerm}
                                      onChange={this.handleSearchInput}
                                      onKeyDown={this.handleKeyDown}
                                    />*/}
              </div>

              {/* Table / Empty State */}
              <div id="masterTableContainer" className="taxmaster_table" style={{ marginTop: 16 }}>
                {posts.length === 0 ? (
                  <div
                    style={{
                      padding: 40,
                      textAlign: 'center',
                      fontSize: 14,
                      color: '#888',
                      border: '1px dashed #ccc',
                      borderRadius: '8px',
                    }}
                  >
                    Upload Invoice to view items
                  </div>
                ) : (
                  <div>
                    <MDBDataTable
                      striped
                      bordered
                      sortable={true}
                      hover
                      data={{
                        columns: [
                          { label: 'S.NO', field: 'sno' },
                          { label: 'Item Code', field: 'itemCode' },
                          { label: 'Item Description', field: 'itemDescription' },
                          { label: 'MRP', field: 'mrp' },
                          { label: 'Item level Discount', field: 'discount' },
                          { label: 'Quantity', field: 'quantity' },
                          { label: 'Pre Tax', field: 'preTax' },
                          { label: 'Post Tax', field: 'postTax' },
                          { label: 'UOM', field: 'uom' },
                          { label: 'Cost', field: 'cost' },
                          { label: '', field: 'action' }
                        ],
                        rows: posts.map((item, index) => ({
                          sno: index + 1,
                          itemCode: item['item_code'],
                          itemDescription: item['item_description'],
                          mrp: item['mrp'],
                          discount: item['item_level_discount'],
                          quantity: item['quantity'],
                          preTax: item['pre_tax'],
                          postTax: item['post_tax'],
                          uom: item['uom'],
                          cost: item['cost'],
                          action: (
                            <div className="action-menu">
                              <button className="action-menu-button">⋮</button>
                              <div className="action-menu-content">
                                <div style={{ fontSize: 12 }} onClick={() => this.confirmToggle(index, item['item_code'])}><img style={{ width: '11%', marginRight: 6 }} src={dustbinIcon} />Remove Item</div>
                                <div style={{ fontSize: 12 }} onClick={() => this.editItem(index, item)}><img style={{ width: '11%', marginRight: 6 }} src={editIcon} /> Edit Item</div>

                              </div>
                            </div>
                          )
                        }))
                      }}
                      paging={false}
                      searching={true}
                    />
                  </div>
                )}
              </div>
            </AccordionItemPanel>
          </AccordionItem>


          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton id="accordion_button">
                <span className="accordian_title">Total </span>
                {/*<span style={{ float: "right", color: this.state.sectionStatus.uomDetails ? "green" : "orange" }}>
                                        <i className={`fa ${this.state.sectionStatus.uomDetails ? "fa-check-circle" : "fa-exclamation-circle"}`}></i>
                                        {this.state.sectionStatus.uomDetails ? " Completed" : " Pending"}
                                    </span>*/}
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <Row form>
                <Col md={4}>
                  <FormGroup>
                    <Label for="email">Total Bill Amount<span style={{ color: "red" }}>*</span></Label>
                    <Input
                      type="text"
                      name="total_bill_amount"
                      id="email"
                      value={this.state.total_bill_amount}
                      onChange={this.handleChange}
                    />
                    {this.state.formErrors && this.state.formErrors.total_bill_amount && (
                      <div style={{ color: 'red', fontSize: 12 }}>{this.state.formErrors.total_bill_amount}</div>
                    )}

                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label for="mobile">Bill Level Discount (RPA)</Label>
                    <Input
                      type="text"
                      name="bill_level_discount"
                      id="mobile"
                      value={this.state.bill_level_discount}
                      onChange={this.handleChange}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </AccordionItemPanel>
          </AccordionItem>

          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton id="accordion_button">
                <span className="accordian_title">Invoice Attachment </span>
                {/*<span style={{ float: "right", color: this.state.sectionStatus.uomDetails ? "green" : "orange" }}>
                                        <i className={`fa ${this.state.sectionStatus.uomDetails ? "fa-check-circle" : "fa-exclamation-circle"}`}></i>
                                        {this.state.sectionStatus.uomDetails ? " Completed" : " Pending"}
                                    </span>*/}
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <Row form>

                <Col md={5}>
                  <div>
                    <span style={{ color: 'black', fontWeight: 500 }}>Invoice Upload <span style={{ color: "red" }}> * </span></span>

                    {/* Upload Area */}
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: 6 }}>
                      {/* Upload or File Display */}
                      {/* Upload or File Display */}
                      {!selectedFileInvoice ? (
                        <div
                          style={{
                            display: 'flex',
                            border: '1px solid #E4E4E7',
                            padding: '10px 12px',
                            borderRadius: '10px',
                            alignItems: 'center',
                            minWidth: 300,
                            maxWidth: 400,
                          }}
                        >
                          <span style={{ fontSize: 13, color: '#7C7C85', flex: 1 }}>Upload documents in .pdf</span>
                          <input
                            type="file"
                            accept=".pdf"
                            style={{ display: 'none' }}
                            id="invoicefileUpload"
                            onChange={this.invoiceFileUpload}
                          />


                          <label htmlFor="invoicefileUpload" style={{ fontSize: 12, color: '#121212', padding: '6px 15px', border: '1px solid #FFCB05', borderRadius: 8, cursor: 'pointer' }}>
                            <img src={blackUploadIcon} style={{ width: '22%' }} /> Attach
                          </label>
                        </div>
                      ) : (
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            border: '1px solid #E4E4E7',
                            padding: '8px 12px',
                            borderRadius: '10px',
                            backgroundColor: '#F2F4F7',
                            minWidth: 300,
                            maxWidth: 400,
                          }}
                        >
                          <span style={{ color: '#1E90FF', fontSize: 13, flex: 1 }}>
                            {selectedFileInvoice.name}
                          </span>
                          <button
                            onClick={this.removeInvoiceUploadedFile}
                            style={{
                              border: 'none',
                              background: 'transparent',
                              cursor: 'pointer',
                              fontSize: 16,
                              color: '#777',
                            }}
                          >
                            ✖
                          </button>
                        </div>
                      )}
                    </div>
                    {this.state.fileErrorInvoice && (
                      <div style={{ color: 'red', marginTop: 8 }}>
                        {this.state.fileErrorInvoice}
                      </div>
                    )}
                  </div>
                  {this.state.formErrors && this.state.formErrors.invoice_upload && (
                    <div style={{ color: 'red', marginTop: 8 }}>
                      {this.state.formErrors.invoice_upload}
                    </div>
                  )}
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label for="mobile">Invoice Number<span style={{ color: "red" }}> * </span></Label>
                    <Input
                      type="text"
                      name="invoice_number"
                      id="mobile"
                      value={this.state.invoice_number}
                      onChange={this.handleChange}
                    />
                    {this.state.formErrors && this.state.formErrors.invoice_number && (
                      <div style={{ color: 'red', fontSize: 12 }}>{this.state.formErrors.invoice_number}</div>
                    )}
                  </FormGroup>
                </Col>
              </Row>
              {/*
                                {this.state.pdfDataUrl && (
                                  <iframe
                                    src={this.state.pdfDataUrl}
                                    title="Invoice Preview"
                                    width="100%"
                                    height="500px"
                                    style={{ border: '1px solid #ccc', marginTop: 10 }}
                                  />
                                )}*/}





            </AccordionItemPanel>
          </AccordionItem>


          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton id="accordion_button">
                <span className="accordian_title">Terms & Condition </span>
                {/*<span style={{ float: "right", color: this.state.sectionStatus.uomDetails ? "green" : "orange" }}>
                                        <i className={`fa ${this.state.sectionStatus.uomDetails ? "fa-check-circle" : "fa-exclamation-circle"}`}></i>
                                        {this.state.sectionStatus.uomDetails ? " Completed" : " Pending"}
                                    </span>*/}
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>

              <Row form>
                <Col md={12}>
                  <FormGroup>
                    <Label for="email">Terms & Condition</Label>
                    <Input
                      type="text"
                      name="term_condition"
                      id="email"
                      value={this.state.term_condition}
                      onChange={this.handleChange}
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label for="mobile">Notes or Description</Label>
                    <Input
                      type="text"
                      name="notes_description"
                      id="mobile"
                      value={this.state.notes_description}
                      onChange={this.handleChange}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>

        {this.state.isAccordionOpen && (
          <div style={{

            bottom: 0,
            left: 0,
            width: '100%',
            backgroundColor: 'white',
            boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.1)',
            padding: '15px 0',
            textAlign: 'center'
          }}>
            <button
              onClick={this.toggleBack}
              style={{
                backgroundColor: 'white',
                border: '2px solid #FBBB00',
                color: 'black',
                padding: '8px 50px',
                fontSize: '16px',
                marginRight: '10px',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              Cancel
            </button>

            <button
              onClick={this.createItem}
              id="createUserBtn"
              style={{
                backgroundColor: '#FBBB00',
                border: 'none',
                color: 'black',
                padding: '10px 55px',
                fontSize: '16px',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              Submit
            </button>
          </div>
        )}

        <Modal isOpen={modalNew} backdrop="static" toggle={this.toggleNew}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggleNew}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h5>{this.state.success_message} </h5>

          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggleBack}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={failedModal} backdrop="static" toggle={this.Failedtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Failedtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h4 style={{ padding: 4 }}>{this.state.failed_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.Failedtoggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>
        <Modal isOpen={confirmModal} backdrop="static" toggle={this.confirmToggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.confirmToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h4 style={{ padding: 4 }}>{this.state.confirmMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            {/*<Button
                        style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                        className="modal_ok"
                        onClick={this.removeItem}
                      >
                        Ok
                      </Button>*/}

            <button
              className="btn"
              style={{ border: '1px solid #FFCB05', color: '#000', backgroundColor: 'white', marginRight: 12 }}
              onClick={this.confirmToggle}
            >
              NO
            </button>
            <button
              className="btn"
              style={{ backgroundColor: '#FFCB05', color: '#000', fontWeight: 500, }}
              onClick={() => this.removeItem(this.state.itemIndex, this.state.itemCode)}
            >
              YES
            </button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={this.state.modalAddItem} backdrop="static" toggle={this.toggleAddItem} className="modal-lg">
          <div className="modal__header" style={{ borderTop: '5px solid #FFCB05', padding: '20px 20px 0', backgroundColor: '#fff' }}>
            <h5 style={{ fontWeight: 600, textAlign: 'left' }}>{this.state.modalHeading}</h5>
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              onClick={this.toggleAddItem}
              style={{ position: 'absolute', right: 15, top: 15, background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: 'black' }}
            />
          </div>

          <div className="modal__body" style={{ padding: '30px 20px 0' }}>
            <Row id="modalForm" form>
              <Col md={6}>
                <FormGroup style={{ textAlign: 'left' }}>
                  <Label for="email">S No.</Label>
                  <Input
                    type="text"
                    id="email"
                    name="sl_num"
                    value={this.state.sl_num}
                    onChange={this.handleChange}
                    readOnly
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup style={{ textAlign: 'left' }}>
                  <Label for="mobile">Item Code</Label>
                  <Input
                    type="text"
                    name="item_code"
                    id="mobile"
                    value={this.state.item_code}
                    onChange={this.handleChange}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row id="modalForm" form>
              <Col md={12}>
                <FormGroup style={{ textAlign: 'left' }}>
                  <Label for="email">Item Description</Label>
                  <Input
                    type="text"
                    name="item_description"
                    value={this.state.item_description}
                    id="email"
                    onChange={this.handleChange}

                  />
                </FormGroup>
              </Col>
            </Row>
            <Row id="modalForm" form>
              <Col md={6}>
                <FormGroup style={{ textAlign: 'left' }}>
                  <Label for="email">MRP</Label>
                  <Input
                    type="number"
                    name="mrp"
                    value={this.state.mrp}
                    id="email"
                    onChange={this.handleChange}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup style={{ textAlign: 'left' }}>
                  <Label for="mobile">Item Level Discount</Label>
                  <Input
                    type="number"
                    name="item_level_discount"
                    value={this.state.item_level_discount}
                    id="mobile"
                    onChange={this.handleChange}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row id="modalForm" form>
              <Col md={6}>
                <FormGroup style={{ textAlign: 'left' }}>
                  <Label for="email">Quantity</Label>
                  <Input
                    type="number"
                    name="quantity"
                    id="email"
                    onChange={this.handleChange}
                    value={this.state.quantity}

                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup style={{ textAlign: 'left' }}>
                  <Label for="mobile">Pre Tax</Label>
                  <Input
                    type="number"
                    name="pre_tax"
                    id="mobile"
                    onChange={this.handleChange}
                    value={this.state.pre_tax}

                  />
                </FormGroup>
              </Col>
            </Row>
            <Row id="modalForm" form>
              <Col md={6}>
                <FormGroup style={{ textAlign: 'left' }}>
                  <Label for="email">Post Tax</Label>
                  <Input
                    type="number"
                    name="post_tax"
                    id="email"
                    onChange={this.handleChange}
                    value={this.state.post_tax}


                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup style={{ textAlign: 'left' }}>
                  <Label for="mobile">UOM</Label>
                  <Input
                    type="number"
                    name="uom"
                    id="mobile"
                    onChange={this.handleChange}
                    value={this.state.uom}

                  />
                </FormGroup>
              </Col>
            </Row>
            <Row id="modalForm" form>
              <Col md={6}>
                <FormGroup style={{ textAlign: 'left' }}>
                  <Label for="email">Cost</Label>
                  <Input
                    type="number"
                    name="cost"
                    id="email"
                    onChange={this.handleChange}
                    value={this.state.cost}


                  />
                </FormGroup>
              </Col>
            </Row>
          </div>

          <div className="modal__footer" style={{ padding: '20px', display: 'flex', gap: '10px' }}>
            <button
              className="btn"
              style={{ border: '1px solid #FFCB05', color: '#000', backgroundColor: 'white' }}
              onClick={this.toggleAddItem}
            >
              Cancel
            </button>
            <button
              className="btn"
              style={{ backgroundColor: '#FFCB05', color: '#000', fontWeight: 500 }}
              onClick={this.handleAddItemSubmit}
            >
              {this.state.editingIndex !== null ? 'Update Item' : 'Add Item'}
            </button>

          </div>
        </Modal>





      </div>
    );
  }
}

export default HorizontalForm;
